import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
var _effectorFileName = "/builds/gmini/ui-common/src/IssueOfficialReplyForm/IssueOfficialReplyForm.tsx";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.is-array.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useState } from 'react';
import { Button } from '../Button';
import { IconButton } from '../IconButton';
import { RoundedCross } from '../icons/';
import { ButtonContainer, Dialog, InfoText, SmallText, TextArea, Title, TitleContainer, Wrapper } from './IssueOfficialReplyForm.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var IssueOfficialReplyForm = function IssueOfficialReplyForm(_ref) {
  var open = _ref.open,
      _onClose = _ref.onClose,
      onSubmit = _ref.onSubmit;

  //TODO: код когда понадобится прикреплять документы
  // const [attachedDocuments, setAttachedDocuments] = useState([])
  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      description = _useState2[0],
      setDescription = _useState2[1];

  var handleSubmit = function handleSubmit() {
    onSubmit({
      description: description
    });
    onResetComment();

    _onClose();
  };

  var onResetComment = function onResetComment() {
    setDescription('');
  };

  return /*#__PURE__*/_jsx(Dialog, {
    open: open,
    onClose: function onClose() {
      onResetComment();

      _onClose();
    },
    children: /*#__PURE__*/_jsxs(Wrapper, {
      children: [/*#__PURE__*/_jsxs(TitleContainer, {
        children: [/*#__PURE__*/_jsx(Title, {
          children: "\u0417\u0430\u043C\u0435\u0447\u0430\u043D\u0438\u0435 \u0443\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u043E"
        }), /*#__PURE__*/_jsx(IconButton, {
          onClick: function onClick() {
            _onClose();

            onResetComment();
          },
          children: /*#__PURE__*/_jsx(RoundedCross, {})
        })]
      }), /*#__PURE__*/_jsx(InfoText, {
        children: "\u0415\u0441\u043B\u0438 \u0440\u0430\u0431\u043E\u0442\u0430 \u043F\u043E \u0443\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0438\u044E \u0434\u0430\u043D\u043D\u043E\u0433\u043E \u0437\u0430\u043C\u0435\u0447\u0430\u043D\u0438\u044F \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0430, \u0441\u0444\u043E\u0440\u043C\u0438\u0440\u0443\u0439\u0442\u0435 \u043E\u0444\u0438\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0439 \u043E\u0442\u0432\u0435\u0442 \u0434\u043B\u044F \u0438\u043D\u0438\u0446\u0438\u0430\u0442\u043E\u0440\u0430 \u0437\u0430\u043C\u0435\u0447\u0430\u043D\u0438\u044F."
      }), /*#__PURE__*/_jsx(SmallText, {
        children: "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439"
      }), /*#__PURE__*/_jsx(TextArea, {
        value: description,
        onChange: function onChange(e) {
          return setDescription(e.currentTarget.value);
        },
        autoFocus: true
      }), /*#__PURE__*/_jsxs(ButtonContainer, {
        children: [/*#__PURE__*/_jsx(Button, {
          color: "secondary",
          onClick: function onClick() {
            onResetComment();

            _onClose();
          },
          children: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C"
        }), /*#__PURE__*/_jsx(Button, {
          disabled: !description.trim(),
          onClick: handleSubmit,
          children: "\u041F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C"
        })]
      })]
    })
  });
};